import styled from 'styled-components';
import MicIcon from '../../assets/learn-mic.svg?react';
import { shortScreen } from './learn_screen_parts.tsx';

// The "Hearing you" meter every listening Learn exercise draws (issues #3473, #3481, #3510,
// #3518), from the "Range Finder" artboard: a grey pill with the mic icon, a level bar and its
// label. It belongs to the screens that are really listening - the Range Finder's direction
// screen, Pitch Match's mic check - so it is always live and carries no margin of its own; the
// screen that mounts it spaces it.

// The test ids are historically named after the Range Finder, where the meter started; they are
// the values the existing stories match, so they keep the 'range-' spelling for every exercise.
export const learnMeterTestId = 'range-meter';
export const learnMeterFillTestId = 'range-meter-fill';

// `level` is 0..1 from the state machine
export const HearingYouMeter = ({ level }: { level: number }) => {
  const shown = Math.min(1, Math.max(0, level));
  return (
    <MeterRow data-testid={learnMeterTestId} data-level={shown.toFixed(2)}>
      <MicIcon aria-hidden="true" />
      <Track>
        <Fill data-testid={learnMeterFillTestId} style={{ width: `${shown * 100}%` }} />
      </Track>
      <MeterLabel>Hearing you</MeterLabel>
    </MeterRow>
  );
};

const MeterRow = styled.div`
  flex: none; // a direct child of the screen body's flex column: the slacks move, the meter does not
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 10px;
  background-color: var(--color-background-search);

  svg {
    flex: none;
    width: 20px;
    height: 20px;
    color: var(--color-tab-selected);
  }

  ${shortScreen} {
    padding: 8px 12px;
  }
`;

const Track = styled.div`
  flex: auto;
  height: 8px;
  border-radius: 4px;
  background-color: var(--color-divider);
  overflow: hidden;
`;

const meterFillColor = '#9240ff'; // the canvas's meter purple, the same in both themes

// No transition: the Range Finder and Pitch Match feed the level on every frame, and a transition
// retargeted that often never completes in WebKit (issue #3587); the frames alone move it smoothly.
const Fill = styled.div`
  height: 100%;
  border-radius: 4px;
  background-color: ${meterFillColor};
`;

const MeterLabel = styled.div`
  flex: none;
  font-size: 13px;
  line-height: 18px;
  color: var(--color-text-darker);
  white-space: nowrap;
`;
